/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';
import { IBalanceDetailsResponse } from '../../entities/Billing/BalanceDetailsResponse';
import { IRequestedHoldPayment } from '../../entities/Billing/RequestedHoldPayment';

export type TBuyPackageModel = IModel<IBuyPackageRequest, TBuyPackageResponse>;

export interface IBuyPackageRequest {
  /** Холдировать **/
  needHold?: boolean | null;
  /** Id рекомендованного пакета, который покупает пользователь **/
  packageId: number;
  /** Нужно ли автоматически продлять пакет **/
  autoProlong?: boolean | null;
  /** Ids полигонов на которые формируется рекомендованный пакет **/
  polygonIds?: number[] | null;
  /** Виджет инициирующий создание пакета **/
  widgetSource?: EWidgetSource | null;
}

export type TBuyPackageResponse = IBuyPackageResponse200 | IBuyPackageResponse400;

export interface IBuyPackageResponse200 extends IModelResponse<IBuyPackageResponse> {
  statusCode: 200;
}

export interface IBuyPackageResponse400 extends IModelResponse<IBuyPackageResponseError> {
  statusCode: 400;
}

export interface IBuyPackageResponse {
  balanceDetails?: IBalanceDetailsResponse | null;
  heldPayment?: IRequestedHoldPayment | null;
  /** Состояние оплаты пакета () **/
  isPaid?: boolean | null;
  /** Номер активированного пакета **/
  servicePackageId?: number | null;
  /** Сообщение в случаи ошибки **/
  message?: string | null;
  /** Код ответа **/
  code?: ECode | null;
}

export interface IBuyPackageResponseError {
  errors: any[];
  message: string;
}

export type TResponses = IBuyPackageResponse | IBuyPackageResponseError;

export enum ECode {
  /** Пакет добавлен и куплен **/
  Ok = 'Ok',
  /** Недостаточно денег для покупки пакета **/
  NotEnoughMoney = 'NotEnoughMoney',
  /** Пользователь не авторизован **/
  NotAuthorised = 'NotAuthorised',
  /** Услуга не доступна **/
  TariffNotAvailable = 'TariffNotAvailable',
  /** Не выбраны услуги в пакете **/
  ServicesNotSelected = 'ServicesNotSelected',
  /** Общая ошибка **/
  Error = 'Error',
}

export enum EWidgetSource {
  /** Пакеты в ЛК **/
  Lk = 'lk',
  /** Форма подачи **/
  AddForm = 'addForm',
  /** Админка пакетов **/
  ServicePackageAdmin = 'servicePackageAdmin',
  /** Админка подписок **/
  SubscriptionAdmin = 'subscriptionAdmin',
  /** Мобилка **/
  Mobile = 'mobile',
  /** Промокоды **/
  Promocodes = 'promocodes',
  /** Smart-пакеты **/
  Smartpack = 'smartpack',
  /** All-in, частный случай смарт-пакета, ключевое отличие: 1 - может пролонгироваться, 2 - может не иметь даты окончания, на фронт отдается через штатную ручку get-smart-package **/
  AllIn = 'allIn',
  AddFormAllIn = 'addFormAllIn',
  AddFormSmartPack = 'addFormSmartPack',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: IBuyPackageResponse): TResponse200;
  400(response: IBuyPackageResponseError): TResponse400;
}
